module.exports = __webpack_public_path__ + "static/media/2_en.50c00757.png";